/** Spanish labels for `apps/api` `NOTIFICATION_EVENT_REGISTRY` event types; unregistered codes fall back to the raw string. */
export const NOTIFICATION_EVENT_TYPE_LABELS: Record<string, string> = {
  OrderSubmitted: 'Pedido enviado',
  OrderConfirmed: 'Pedido confirmado',
  CutoffClosed: 'Corte cerrado',
  DeviationAlert: 'Alerta de desvío',
  ChangeRequestCreated: 'Solicitud de cambio creada',
  ChangeRequestResolved: 'Solicitud de cambio resuelta',
  PreCutoffReminder: 'Recordatorio de corte',
  PortalInvitationSent: 'Invitación al portal enviada',
};
